/**
 * Layered guard: the user must be authenticated AND active AND a super admin.
 *
 * Expected to be wrapped inside `<RequireAuth>`, which handles the
 * authentication + status chain. This component only adds the final
 * super-admin check; non-admins get bounced to /dashboard.
 */

import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { LoadingShell } from "@/components/LoadingShell";
import { useAuth } from "@/features/auth/useAuth";

interface Props {
  children: ReactNode;
}

export function RequireSuperAdmin({ children }: Props) {
  const { isLoading, isSuperAdmin } = useAuth();

  if (isLoading) {
    return <LoadingShell />;
  }

  if (!isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
